import FetchPromise from '~/agent/fetch-promise';

type Params = {
  guideId: string;
  documentObjectId: string;
  courseTaskAssignmentId: string;
  message: string;
};

export const sendLearnerQuestion = ({ guideId, documentObjectId, courseTaskAssignmentId, message }: Params) =>
  FetchPromise.post(`courses/${guideId}/content_questions`, {
    documentObjectId,
    courseTaskAssignmentId,
    message,
  });
